import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styles } from "./appbar.module.css";
import { useNavigate } from "react-router-dom";

export default function Expandablemenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFindJobs = () => {
    navigate("/jobs");
    handleClose();
  };

  const handlePostJobs = () => {
    navigate("/post-job");
    handleClose();
  };

  return (
    <div style={{ paddingLeft: "8px" }}>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{ color: "#fff", fontWeight: "700", fontFamily: "Nunito" }}
      >
        {"Jobs 💼"}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem style={{ fontFamily: "Nunito" }} onClick={handleFindJobs}>
          {"Find Jobs 💰"}
        </MenuItem>
        <MenuItem style={{ fontFamily: "Nunito" }} onClick={handlePostJobs}>
          {"Post Jobs"}
        </MenuItem>
      </Menu>
    </div>
  );
}
